export default class GenderModel {
  constructor(data) {
    if (!data) {
      data = {};
    }
    this.male = data.male || 0;
    this.female = data.female || 0;
    this.transgender_female = data.transgender_female || 0;
    this.transgender_male = data.transgender_male || 0;
    this.non_binary = data.non_binary || 0;
    this.other = data.other || 0;
    this.unknown = data.unknown || 0;
    this.prefer_not_to_say = data.prefer_not_to_say || 0;
    this.none = data.none || 0;
  }
}
